/** AIHY 小星球：产品地标 + 精灵 */

export type LandmarkId =
  | "aihy"
  | "kaipanla"
  | "zhuoxiang"
  | "fun"
  | "dsa"
  | "elevator"
  | "orbit"
  | "dropwell";

export type NpcId =
  | "wesight"
  | "bluebot"
  | "drop"
  | "flame"
  | "crate"
  | "sprout"
  | "blockbot"
  | "spacer";

export type LandmarkDef = {
  id: LandmarkId;
  name: string;
  subtitle: string;
  /** 外链地址。空字符串表示这座小屋只是风景，不外链。 */
  url: string;
  postcardTitle: string;
  postcardBody: string;
  accent: number;
  roof: number;
  lat: number;
  lon: number;
};

export type NpcDef = {
  id: NpcId;
  name: string;
  title: string;
  lines: string[];
  badgeTitle: string;
  badgeBody: string;
  guideTo: LandmarkId;
  lat: number;
  lon: number;
};

export const HOME_URL = "https://aihy.cc/";

export const BRAND = {
  title: "AIHY 小星球",
  slogan: "AI慧眼的产品，都住在这颗球上。",
  home: "返回 AI慧眼",
};

/** 8 座小屋，均匀铺在球面。6 座有站点，2 座只是风景。 */
export const LANDMARKS: LandmarkDef[] = [
  {
    id: "aihy",
    name: "慧眼天文台",
    subtitle: "全球 AI 情报",
    url: HOME_URL,
    postcardTitle: "望远镜夜班",
    postcardBody: "AI慧眼主站。每天看全球 AI 动向，只留还在长大的信号。",
    accent: 0x7c3aed,
    roof: 0x4c1d95,
    lat: 22,
    lon: 10,
  },
  {
    id: "kaipanla",
    name: "开盘啦灯塔",
    subtitle: "爱合约 · 开盘啦",
    url: "https://kaipanla.aihy.cc/",
    postcardTitle: "灯塔下的刻痕",
    postcardBody: "开盘啦看板。看主力资金和多空动量，不预测下一根 K 线。",
    accent: 0xc4a35a,
    roof: 0x8a6a2e,
    lat: 8,
    lon: 55,
  },
  {
    id: "zhuoxiang",
    name: "拙像画室",
    subtitle: "涂鸦头像小程序",
    url: "https://aihy.cc/zhuoxiang/",
    postcardTitle: "画室便条",
    postcardBody: "拙像。把照片画成稚拙、带时装感的涂鸦头像，只画到下巴，不是滤镜。",
    accent: 0xf59e0b,
    roof: 0x92400e,
    lat: -12,
    lon: 100,
  },
  {
    id: "fun",
    name: "实验室积木塔",
    subtitle: "AIHY 实验室",
    url: "https://fun.aihy.cc/",
    postcardTitle: "未命名积木",
    postcardBody: "AIHY 实验室。小实验都堆在这里，允许翻车，一次只验证一件事。",
    accent: 0x3b82f6,
    roof: 0x1e3a8a,
    lat: -20,
    lon: 160,
  },
  {
    id: "dsa",
    name: "DSA 研究营",
    subtitle: "DSA 研究台",
    url: "https://aihy.cc/dsa/",
    postcardTitle: "营地便笺",
    postcardBody: "DSA 研究台。摊开纸写三行：假设、证据、反例。写不满就不发。",
    accent: 0xdc2626,
    roof: 0x7f1d1d,
    lat: 18,
    lon: -40,
  },
  {
    id: "elevator",
    name: "轨道电梯站",
    subtitle: "一路向上到 100 公里",
    url: "https://aihy.cc/elevator/",
    postcardTitle: "电梯票根",
    postcardBody: "轨道电梯。从地面往上滑到 100 公里，一层一层看高度上有什么。",
    accent: 0x0f766e,
    roof: 0x134e4a,
    lat: 35,
    lon: -90,
  },
  {
    id: "orbit",
    name: "小星球发射台",
    subtitle: "你正在这里",
    url: "",
    postcardTitle: "起点徽章",
    postcardBody: "发射台不起飞。它只提醒一句：所有产品都住在同一颗球上。",
    accent: 0x38bdf8,
    roof: 0x0ea5e9,
    lat: -5,
    lon: -140,
  },
  {
    id: "dropwell",
    name: "数据水滴泉",
    subtitle: "风景，不外链",
    url: "",
    postcardTitle: "一滴样本",
    postcardBody: "泉边没有门。坐一会儿，看水滴和花，然后接着走。",
    accent: 0x38bdf8,
    roof: 0x0369a1,
    lat: 28,
    lon: 200,
  },
];

export const NPCS: NpcDef[] = [
  {
    id: "wesight",
    name: "WeSight 小助手",
    title: "围巾侦察兵",
    lines: ["嘀，信号清洗完毕。", "慧眼天文台在那边，我带你过去。"],
    badgeTitle: "围巾徽章",
    badgeBody: "先过滤，再推送。",
    guideTo: "aihy",
    lat: 16,
    lon: 22,
  },
  {
    id: "flame",
    name: "火焰小人",
    title: "开盘啦热源",
    lines: ["我跑得快，也容易跑过头。", "灯塔的光比较稳，跟我走。"],
    badgeTitle: "火焰围裙",
    badgeBody: "热度可以借，仓位不能借。",
    guideTo: "kaipanla",
    lat: 2,
    lon: 68,
  },
  {
    id: "crate",
    name: "木箱小人",
    title: "画室搬运工",
    lines: ["箱子里装的是画纸和蜡笔。", "拙像画室的门朝这边开。"],
    badgeTitle: "木箱角铁",
    badgeBody: "只画到下巴，不画脖子。",
    guideTo: "zhuoxiang",
    lat: -8,
    lon: 112,
  },
  {
    id: "blockbot",
    name: "积木机器人",
    title: "实验堆叠者",
    lines: ["一块一块叠，塌了再叠。", "实验室积木塔在上坡。"],
    badgeTitle: "紫晶关节",
    badgeBody: "一次只验证一块积木。",
    guideTo: "fun",
    lat: -16,
    lon: 172,
  },
  {
    id: "bluebot",
    name: "蓝色机器人",
    title: "CRT 研究员",
    lines: ["屏幕上只留假设和反例。", "DSA 研究营的红灯笼亮着。"],
    badgeTitle: "CRT 蓝光",
    badgeBody: "证据不够就不发。",
    guideTo: "dsa",
    lat: 12,
    lon: -28,
  },
  {
    id: "spacer",
    name: "太空机器人",
    title: "发射台向导",
    lines: ["头盔里两格蓝眼：准备好了吗？", "小星球发射台就是起点。"],
    badgeTitle: "舱内蓝核",
    badgeBody: "从这里出发，也能走回这里。",
    guideTo: "orbit",
    lat: 0,
    lon: -128,
  },
  {
    id: "drop",
    name: "水滴伙伴",
    title: "泉边观测员",
    lines: ["泉边不赶路，坐一会儿也行。", "水滴泉就在花丛那边。"],
    badgeTitle: "凉水印",
    badgeBody: "先问季节，再问涨跌。",
    guideTo: "dropwell",
    lat: 22,
    lon: 188,
  },
  {
    id: "sprout",
    name: "萌芽小方",
    title: "电梯口园丁",
    lines: ["花盆留在地面，人往上去。", "轨道电梯站在那边，按一下就走。"],
    badgeTitle: "双叶芽",
    badgeBody: "往上走，也记得回头看地面。",
    guideTo: "elevator",
    lat: 30,
    lon: -78,
  },
];

export const LANDMARK_IDS: readonly LandmarkId[] = LANDMARKS.map((item) => item.id);
export const NPC_IDS: readonly NpcId[] = NPCS.map((item) => item.id);

export function landmarkById(id: LandmarkId): LandmarkDef {
  const found = LANDMARKS.find((item) => item.id === id);
  if (!found) throw new Error(`unknown landmark: ${id}`);
  return found;
}

export function npcById(id: NpcId): NpcDef {
  const found = NPCS.find((item) => item.id === id);
  if (!found) throw new Error(`unknown npc: ${id}`);
  return found;
}
